/**
 * ReleaseInfo.tsx
 * Displays basic release information header and Spotify URI input.
 * Shows different display text based on navigation source.
 */

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFormikContext } from 'formik';
import { PitchFormValues } from '../Schema/pitchValidationSchema';

interface LocationState {
  artist?: string;
  release?: string;
  releaseDate?: string;
  fromDashboard?: boolean;
  artistName?: string;
  releaseTitle?: string;
}

const ReleaseInfo: React.FC = () => {
  const location = useLocation();
  const { values, setFieldValue } = useFormikContext<PitchFormValues>();
  const state = location.state as LocationState;
  const { artist = '', release = '', releaseDate = '' } = state || {};

  useEffect(() => {
    if (location.state) {
      if (artist) setFieldValue('artistName', artist);
      if (release) setFieldValue('releaseTitle', release);
      if (releaseDate) setFieldValue('releaseDate', releaseDate);
    }
  }, [location.state, setFieldValue, artist, release, releaseDate]);

  const displayText = state?.fromDashboard 
    ? `${state.artistName} - "${state.releaseTitle}" - ${state.releaseDate}`
    : values.artistName && values.releaseTitle && values.releaseDate
      ? `${values.artistName} - "${values.releaseTitle}" - ${values.releaseDate}`
      : 'Artist Name - "Release Title" - Release Date';

  return (
    <section className="overflow-hidden border rounded-lg border-neutral-200">
      {/* Release Info Header */}
      <div className="p-4 text-white bg-primary-700">
        <span className="text-lg font-semibold">{displayText}</span>
      </div>

      {/* Spotify URI Input - Commented out as it's handled in DSP Specific Info */}
      {/* <div className="mt-6">
        <div className="space-y-2">
          <label className="block mb-2 text-sm font-medium text-neutral-700">
            Spotify Artist URI 
          </label>
          <input
            type="text"
            placeholder="Enter Spotify Artist URI"
            value={values.spotifyUri || ''}
            onChange={(e) => setFieldValue('spotifyUri', e.target.value)}
            className="w-full px-3 py-2 text-sm text-black bg-white border rounded-md outline-none transition-colors border-neutral-300 placeholder-neutral-400 focus:border-primary-500"
          />
        </div>
      </div> */}
    </section>
  );
};

export default ReleaseInfo;